var _rect, _defs, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 60 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "#012169"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 30,
    height: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 30,
    height: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 30,
    height: 15
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L60 30 M0 30 L60 0",
    stroke: "white",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L30 15",
    stroke: "#C8102E",
    strokeWidth: 2,
    transform: "translate(0, 1.5)",
    clipPath: "url(#tl)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15 L60 30",
    stroke: "#C8102E",
    strokeWidth: 2,
    transform: "translate(0, -1.5)",
    clipPath: "url(#br)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0 L30 15",
    stroke: "#C8102E",
    strokeWidth: 2,
    transform: "translate(0, -1.5)",
    clipPath: "url(#tr)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30 L30 15",
    stroke: "#C8102E",
    strokeWidth: 2,
    transform: "translate(0, 1.5)",
    clipPath: "url(#bl)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 0,
    width: 10,
    height: 30,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 60,
    height: 10,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 0,
    width: 6,
    height: 30,
    fill: "#C8102E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12,
    width: 60,
    height: 6,
    fill: "#C8102E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.a8cce80a91fb1cef0758dcfea484cbf6.svg";
export { ForwardRef as ReactComponent };